import React from 'react'
import { FillLevel } from './fillLevels'

const POUCH_FILL_HEIGHT: Record<FillLevel, number> = {
  high: 18,
  medium: 11,
  low: 4
}

const FillGlyph = ({ level }: { level: FillLevel }) => (
  <svg
    className="dosing-levels__glyph"
    width="14"
    height="20"
    viewBox="0 0 14 20"
    aria-hidden="true"
  >
    <rect
      className="dosing-levels__pouch"
      x="0"
      y="0"
      width="14"
      height="20"
      rx="4"
    />
    <rect
      className={`dosing-levels__fill--${level}`}
      x="0"
      y={20 - POUCH_FILL_HEIGHT[level]}
      width="14"
      height={POUCH_FILL_HEIGHT[level]}
      rx="4"
    />
  </svg>
)

export default FillGlyph
